import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Ensure page starts from the top on load
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}
window.scrollTo(0, 0);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Note: StrictMode removed to improve development performance
// StrictMode causes double-renders which significantly slow down dev mode
// Re-enable for debugging: <React.StrictMode><App /></React.StrictMode>
root.render(<App />);














